export default "__VITE_PUBLIC_ASSET__25bdc5ff__"